// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oUXYw","title":"styles_title__1XMkG"};